/*
*###############################################################################
*Module Name                   : DPSearchBoxDynamic.js                                #
*Purpose of the Module         : Search ModalUI                                #
*Description of the Module     : Common Search Modal Component with Table      #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, August 22nd 2021, 7:35:18 am          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal } from "reactstrap"
import "../../assets/scss/datatables.scss"
import ReactPaginate from 'react-paginate';
import "../../assets/scss/searchtable.scss"
import { loadPopupSearchPay } from "framework/validators/SearchColumn";
import DPSwitch from "./DPSwitch";


const DPSearchBoxDynamicWithSwitch = (props) => {

    const [searchPlaceholder, setSearchPlaceholder] = useState(`Search By ${props.columns.length > 0 ? props.columns[0].title : 'Code'}`)
    const [searchBy, setSearchBy] = useState(props.searchBy) //filter code ex: CM_CODE
    const [columns, setColumns] = useState([]) //columns for table
    const [page, setPage] = useState(0) //current page
    const [pageSize, setPageSize] = useState(10) //page size
    const [count, setCount] = useState(0) //total row count
    const [data, setData] = useState([]) //data for table
    const [isLoaded, setIsLoaded] = useState(false)
    const [searchString, setSearchString] = useState("0") //user entered search string
    const [isDataLoaded, setIsDataLoaded] = useState(false)
    const tableRef = useRef(null);
    const [orderBy, setOrderBy] = useState("ASC")//order by ASC or DESC
    const [OrderByString, setOrderByString] = useState(props.columns.length > 0 ? props.columns[0].title : 'Code')
    const [selectedRow, setSelectedRow] = useState(0); //highlight selected row , selected row index
    const [selectedColumn, setSelectedColumn] = useState(0); //selected column for search
    const searchref = useRef(null); //search input ref
    const [searchPlace, setSearchPlace] = useState(0)

    useEffect(async () => { //when model toggle set default values
        setSearchBy(props.searchBy)
        setSearchPlaceholder(`Search By ${props.columns.length > 0 ? props.columns[0].title : 'Code'}`)
        setPage(0)
        setSelectedColumn(0)
        setOrderBy(props.orderBy ? props.orderBy : "ASC")

        if (props.isOpen == true) {
            setData([])
            setIsLoaded(true)


        } else {
            setIsLoaded(false)
            setData([])
        }
        setSearchString("0")

    }, [props.isOpen])


    useEffect(async () => {
        if (isLoaded) {
            setOrderBy(props.orderBy ? props.orderBy : "ASC")
            setColumns(await loadPopupSearchPay(props.MenuCode, props.URLPath)) //get table columns from server 
            await getData(); //get row data from server
        }
    }, [isLoaded])

    useEffect(async () => {
        await getData();
    }, [page, pageSize, searchString, orderBy, searchBy]) // when page, page size, search string, order by, search by change get data from server


    async function getData() {
        if (props.MenuCode == undefined || props.MenuCode == null || props.MenuCode == "") return // if menu code is not set return from function
        const authToken = localStorage.getItem("authToken")
        setIsDataLoaded(true)

        var FilterString = props.FilterStr;

        await fetch(`${props.APIURL}common/dsearch`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify({
                strMenuCode: props.MenuCode,
                strSearchControl: props.URLPath,
                strSearchKey: props.KeyVal,
                strSearchCol: searchBy,
                strSearchVal: searchString === "" ? "0" : searchString,
                intPageNo: page,
                intRowPerPage: pageSize,
                strFilter: FilterString,
                orderBy: orderBy,
                searchPlace: searchPlace
            })
        }).then(async (Response) => await Response.json())
            .then(async (responseData) => {
                if (responseData.success == true) {
                    var tabledata = responseData.data
                    var pagecount = responseData.count

                    setCount(pagecount)
                    setData(tabledata)

                } else {
                    setCount(0)
                    setData([])
                }
                setIsDataLoaded(false)
            })
    }

    const handlePageClick = (event) => {
        setPage(event.selected);
    };

    if (searchref.current) {
        searchref.current.focus()
    }

    const handleKeyPress = (event) => { // key press event handling function 
        if (event.key === 'ArrowUp') { // if key is arrow up select previous row
            event.preventDefault();
            setSelectedRow((selectedRow) => Math.max(selectedRow - 1, 0));
        } else if (event.key === 'ArrowDown') { // if key is arrow down select next row
            event.preventDefault();
            setSelectedRow((selectedRow) => Math.min(selectedRow + 1, data.length - 1));
        } else if (event.key === 'Enter') { // if key is enter call select function
            if (data.length == 0) return
            props.getSelect(event, data[selectedRow])
        } else if (event.key === 'ArrowRight') { // if key is arrow right select next page
            setPage(e => {
                if (e + 1 <= count / pageSize) {
                    return e + 1
                } else {
                    return e
                }
            })
            setSelectedRow(0) // set selected row to 0 when page no cahge
        } else if (event.key === 'ArrowLeft') { // if key is arrow left select previous page
            setPage(e => {
                if (e - 1 >= 0) {
                    return e - 1
                } else {
                    return e
                }
            })
            setSelectedRow(0) // set selected row to 0 when page no cahge
        }

        if (event.ctrlKey && event.key == 'x') {
            // add your code to handle the Control + X key event here

            setSearchPlace(searchPlace == 0 ? 1 : 0)
        }

    };


    const handleOptionChange = (event) => {
        setSearchPlace(event.target.value);
    };

    return (
        <div onKeyDown={handleKeyPress}
        >
            <Modal
                id="dynamicSearchModal"
                size="xl"
                isOpen={props.isOpen}
                toggle={props.toggle}
                centered
            >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myExtraLargeModalLabel"
                    >
                        {props.mainTitle}
                    </h5>
                    <button
                        onClick={props.toggle}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4">{props.SubTitle} </CardTitle>
                                    <p className="card-title-desc">
                                        {"Please click on the column header to change searching criteria."}
                                    </p>
                                    <>
                                        <div className="row mb-3 justify-content-end">
                                            <div className="col-9">
                                                <div className="form-group">
                                                    <div className="input-group-prepend">
                                                        <label htmlFor="option1" className="pr-5">
                                                            <input type="radio" name="option" id="option1" value="0" checked={searchPlace == 0} onClick={handleOptionChange} />
                                                            <span className="mx-2">Search by Middle Letter</span>
                                                        </label>
                                                        <label htmlFor="option2" className="px-5">
                                                            <input type="radio" name="option" id="option2" value="1" checked={searchPlace == 1} onClick={handleOptionChange} />
                                                            <span className="mx-2">Search by First Letter</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-3">
                                                <div className="form-group">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text" id="basic-addon1"><i className="mdi mdi-magnify"></i></span>
                                                        </div>
                                                        <input ref={searchref} id="SearchBarDynamic" type="text" className="form-control" placeholder={searchPlaceholder} aria-label="Username" aria-describedby="basic-addon1" onChange={e => {
                                                            setSearchString(e.target.value) // set search string
                                                            setPage(0) // set page no to 0  when search string change
                                                        }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    <>
                                        <table className="table table-bordered  table-sm rounded" ref={tableRef} id="searchTable">
                                            <thead style={{ height: "35px", alignItems: "center", verticalAlign: "middle" }}>
                                                {columns.map((column, index) => {
                                                    return (
                                                        <th key={index} style={{ textAlign: column.align, cursor: "pointer", background: "gainsboro" }} onClick={e => {
                                                            setPage(0)
                                                            setSearchBy(column.field)
                                                            setSearchPlaceholder(`Search By ${column.title}`)
                                                            setOrderByString(column.title)
                                                            setSearchString("0")

                                                            const element = document.getElementById("SearchBarDynamic");

                                                            if (element) {
                                                                element.focus();
                                                            }

                                                            setSelectedColumn(pre => {
                                                                if (pre == index) {
                                                                    orderBy == "ASC" ? setOrderBy("DESC") : setOrderBy("ASC")
                                                                } else {
                                                                    setOrderBy("ASC")
                                                                }
                                                                return index
                                                            })
                                                        }}>{column.title}  {selectedColumn == index ? orderBy == "ASC" ? " ▲" : " ▼" : ""}</th>
                                                    )
                                                })}
                                                <th style={{ cursor: "pointer", background: "gainsboro" }}></th>
                                            </thead>
                                            <tbody>
                                                {data.length > 0 ? data.map((row, index) => {
                                                    return (
                                                        <tr
                                                            key={index}
                                                            style={{ textAlign: "center" }}
                                                            className={index === selectedRow ? 'selectedrowsearch' : 'unselectedrowsearch'}
                                                            tabIndex={index === selectedRow ? 0 : -1}
                                                            onClick={e => {
                                                                props.getSelect(e, row)
                                                            }}>
                                                            {columns.map((column, index) => {
                                                                return (
                                                                    <td key={index} style={{ textAlign: column.align }}>{row[column.field]}</td>
                                                                )
                                                            })}
                                                            <td>
                                                                <DPSwitch
                                                                    onChange={e => {
                                                                        var switchData = [...props.SwitchData]
                                                                        if (e) {
                                                                            switchData.push(row[columns[0].field])
                                                                            props.SetSwitchData(switchData)
                                                                        } else {
                                                                            var filtered = switchData.filter(e => e !== row[columns[0].field])
                                                                            props.SetSwitchData(filtered)
                                                                        }
                                                                    }}
                                                                    checked={props.SwitchData.includes(row[columns[0].field])}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )
                                                }) : <tr>{props.columns.map((column, index) => {
                                                    return (
                                                        <td> <center>No data found</center></td>
                                                    )
                                                })}</tr>}
                                            </tbody>
                                        </table>
                                    </>
                                    <div className="row-fluid">
                                        <div className="col-6" style={{ display: "inline-block" }}>
                                            <label>
                                                Page Size:
                                            </label>
                                            <select className="form-control" style={{ width: '50px', display: "inline-block", marginLeft: "3px" }} onChange={e => {
                                                setPageSize(e.target.value)
                                            }}>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="30">50</option>
                                                <option value="40">100</option>
                                            </select>
                                        </div>

                                        <div className="col-6" style={{ display: "inline-block" }}>
                                            <ReactPaginate
                                                previousLabel={'Previous'}
                                                nextLabel={'Next'}
                                                breakLabel={'...'}
                                                pageClassName="page-item"
                                                pageLinkClassName="page-link"
                                                previousClassName="page-item"
                                                previousLinkClassName="page-link"
                                                nextClassName="page-item"
                                                nextLinkClassName="page-link"
                                                breakClassName="page-item"
                                                breakLinkClassName="page-link"
                                                pageCount={Math.ceil(count / pageSize)}
                                                pageRangeDisplayed={2}
                                                onPageChange={handlePageClick}
                                                forcePage={page}
                                                renderOnZeroPageCount={null}
                                                activeClassName={'active'}
                                                activeLinkClassName={'page-link'}
                                                containerClassName={'pagination justify-content-end pagination-sm'}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mb-3 justify-content-end">

                                        <div className="col-6" style={{ display: "inline-block", textAlign: "end" }}>
                                            {/* page total row count display */}
                                            <label>
                                                Total Row Count: {Math.ceil(count)}
                                            </label>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </div>
            </Modal>

        </div>
    );
}

export default DPSearchBoxDynamicWithSwitch;













// data = {(query) =>
// new Promise(async (resolve, reject) => {
//     console.log(Date.now())
//     if (query.orderBy != undefined) {
//         setSearchPlaceholder("Search By " + query.orderBy.title)
//         setSearchBy(query.orderBy.field)
//     }

//     let val
//     if (query.search) {
//         val = query.search
//     }
//     var tabledata = []
//     const authToken = localStorage.getItem("authToken")
//     var count = []
//     //debugger;
//     await fetch(`${props.APIURL}common/dsearch/${props.MenuCode}/${props.URLPath}/${props.KeyVal}/${searchBy}/${val == undefined ? '0' : val}/${query.page == undefined || query.page == null || query.page == "" ? '0' : query.page}/${query.pageSize}/${props.FilterStr == undefined ? 'a' : props.FilterStr}`, {
//         method: "GET",
//         headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${authToken}`
//         },
//     }).then(async (Response) => await Response.json())
//         .then(async (responseData) => {
//             tabledata = responseData.data
//             count = responseData.count
//             console.log(tabledata)
//             console.log(Date.now())
//         })
//     //console.log(query.orderBy.field)
//     if (query.orderDirection === 'asc') {
//         tabledata.sort((a, b) => a[query.orderBy.field] > b[query.orderBy.field] ? 1 : -1);
//     }

//     if (query.orderDirection === 'desc') {
//         tabledata.sort((a, b) => a[query.orderBy.field] > b[query.orderBy.field] ? -1 : 1);
//     }
//     resolve({
//         data: tabledata,// your data array
//         page: query.page,// current page number
//         totalCount: count// total row number
//     });
// })
//                                         }